import {
    Button,
    Col,
    Form,
    InputGroup,
    OverlayTrigger,
    Row,
    Tooltip,
} from "react-bootstrap";
import { Controller } from "react-hook-form";
import { FaCog, FaUndo } from "react-icons/fa";

const GenericFormGroup = ({
    name,
    label,
    control,
    errors,
    defaultValue,
    setValue,
    renderInput,
    distribution,
}) => {
    // Function to safely access nested errors
    const getErrorMessage = (errors, path) => {
        return path.split(".").reduce((acc, segment) => acc?.[segment], errors)
            ?.message;
    };

    const errorMessage = getErrorMessage(errors, name);
    const hasResetAbility =
        defaultValue !== undefined && setValue !== undefined;

    const resetValue = () => {
        if (hasResetAbility) {
            console.log(`Reset value of ${name} to ${defaultValue}`);
            setValue(name, defaultValue, {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true,
            });
        }
    };

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Reset to default value
        </Tooltip>
    );

    return (
        <Form.Group as={Row} className="mb-2" controlId={label}>
            <Controller
                name={name}
                control={control}
                render={({ field }) => {
                    const displayField = {
                        ...field,
                        value: field.value ?? "",
                    };

                    const normalizeComparableValue = (value) => value ?? "";

                    const canResetToDefault =
                        hasResetAbility &&
                        String(normalizeComparableValue(field.value)) !==
                            String(normalizeComparableValue(defaultValue));

                    return (
                        <>
                            <Form.Label
                                column
                                sm={distribution?.[0] ?? 3}
                                style={{
                                    fontWeight: canResetToDefault
                                        ? "bold"
                                        : "normal",
                                }}
                            >
                                {label}
                            </Form.Label>
                            <Col sm={distribution?.[1] ?? 9}>
                                <InputGroup>
                                    {renderInput(
                                        displayField,
                                        canResetToDefault,
                                        errorMessage,
                                    )}
                                    {hasResetAbility && (
                                        <OverlayTrigger
                                            delay={{ show: 250 }}
                                            overlay={renderTooltip}
                                        >
                                            <Button
                                                variant="outline-secondary"
                                                onClick={resetValue}
                                                disabled={!canResetToDefault}
                                            >
                                                <FaCog />
                                                <FaUndo />
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                </InputGroup>
                                {errorMessage && (
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="d-block ms-2"
                                    >
                                        {errorMessage}
                                    </Form.Control.Feedback>
                                )}
                            </Col>
                        </>
                    );
                }}
            />
        </Form.Group>
    );
};

export default GenericFormGroup;
